import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/services/http.service';
import { ensureActiveSubscription } from 'src/app/shared/subscription-dialog';
import { URLUtils } from 'src/app/urlUtils';
import { environment } from 'src/environments/environment';
import { LeavepageComponent } from '../leavepage/leavepage.component';
import { ConfirmationDialogService } from './../../../../confirmation-dialog/confirmation-dialog.service';
import { MatterService } from './../../../matter.service';
import { HostListener } from '@angular/core';

@Component({
    selector: 'matter-info',
    templateUrl: 'matter-info.component.html',
    styleUrls: ['matter-info.component.scss'],
    standalone: false
})
export class MatterInfoComponent implements OnInit {
  @Input() type: string = 'create';
  @Input() data: any;
  @Input() matterId: any;
  @Output() childButtonEvent = new EventEmitter();
  events: string[] = [];
  advicates: any
  caseRegister: any = FormGroup;
  desc: any; 
  tags: any = [];
  //memberDetail:any=FormGroup;
  submitted = false;
  opponent_advocates: any = [];
  pipe = new DatePipe('en-US');
  isEdit: boolean = false;
  selectedPriority: string = "High";
  selectedStatus: string = "Active";
  editeMatterInfo: any;
  Documents: any;
  isAddDisable: boolean = false;
  matterid:any;
  legalMatters: any = [];
  caseTypes: any = [];
  showMore: boolean = false;
  getMatterId: any;
  product = environment.product;
  createdatePickerConfig = {
    dateInputFormat: 'MMM DD, YYYY',
    showWeekNumbers: false,
    showClearButton: true,
    maxDate: new Date()
  };
  datePickerConfig = {
    dateInputFormat: 'MMM DD, YYYY',
    showWeekNumbers: false,
    showClearButton: true
  };
saveLate =false;
isOpen = false;
selectedCaseType = '';


  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent) {
    if (this.caseRegister?.dirty || this.caseRegister?.touched) {
      event.preventDefault();
      event.returnValue = ''; // to show warning
    }
  }
  @HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  const target = event.target as HTMLElement;

  if (!target.closest('.custom-select')) {
    this.isOpen = false;
  }
}

  readonly NoWhitespaceRegExp: RegExp = new RegExp("\\S");
  //minDate:any=new Date();
  constructor(private fb: FormBuilder, private oa: FormBuilder, private matterService: MatterService, private toast: ToastrService,private datePipe: DatePipe,
    private httpService: HttpService, private dialog: MatDialog, private spinnerService: NgxSpinnerService, private router: Router, private confirmationDialogService: ConfirmationDialogService) { }

  ngOnInit() {
    this.caseRegister = this.fb.group({
      title: ['',[Validators.required,Validators.pattern(this.NoWhitespaceRegExp)]],
      case_number: ['',[Validators.pattern(this.NoWhitespaceRegExp)]],
      matter_number: ['', Validators.required],
      date_of_filling: [new Date()],
      description: [''],
      tags:[''],
      case_type: [''],
      created_date:  [new Date()],
      court_name: [''],
      judges: [''],
      status: ['Active'],
      priority: ['High']
    })
    // console.log("Matter caseRegister Info:", this.caseRegister.value);  
    // console.log('isEdit',this.isEdit)
    // console.log('data',this.data)
    // console.log('showMore',this.showMore)
    // console.log('editmmm',this.editeMatterInfo)
    // console.log('mattId',this.matterid)


    if (!this.data) {
      if (window.location.pathname.indexOf("create") > -1) {
        this.getMatterID();
      }

    }
          
    this.getMatterCaseType();
    console.log('data',this.data)

    if (this.data) {
      this.caseRegister.patchValue(this.data);
      if (this.data.date_of_filling) {
        this.caseRegister.controls["date_of_filling"].setValue(new Date(this.data.date_of_filling));
      }
      if (this.data.status) {
        this.caseRegister.controls["status"].setValue((this.data.status));
      }
      if (this.data.priority) {
        this.caseRegister.controls["priority"].setValue((this.data.priority));
      } 
      // if (this.data.caseType) {
      //   this.caseRegister.controls["case_type"].setValue(this.data.caseType); //get casetype
      // }
     
      const caseType = this.data.case_type || this.data.caseType || '';
      this.caseRegister.controls["case_type"].setValue(caseType);
      this.selectedCaseType = caseType;

      this.selectedStatus = this.data.status;
      this.selectedPriority = this.data.priority;
      // console.log('ng data',this.data)
      // console.log("editmeminfooo: ", this.editeMatterInfo)
    }
    if (window.location.pathname.indexOf("edit") > -1) {
      this.showMore=true;
      //console.log('tt showMore',this.showMore)

      this.matterService.editLegalMatterObservable.subscribe((result: any) => {
        console.log('edit legal matter result: ', result)
        // this.httpService.sendGetRequest(URLUtils.getLegalMatterInfoDetails(result.id)).subscribe((res: any) => {
        //   console.log('Fetched matter details for ID', res.matter);
        // });
        if (result) {
          this.applyMatterToForm(result);

          this.editeMatterInfo = result;
          this.matterid = result.id;
          // console.log('...editMatter',this.editeMatterInfo)
          // console.log('mattId',this.matterid)

          this.isEdit = true;
          //this.type ='edit'
          
          this.caseRegister.patchValue(this.editeMatterInfo);
          if (this.editeMatterInfo.date_of_filling) {
          this.caseRegister.controls["date_of_filling"].setValue(new Date(this.editeMatterInfo.date_of_filling));
          }
          if (this.editeMatterInfo.created_date) {
           this.caseRegister.controls["created_date"].setValue(new Date(this.editeMatterInfo.created_date));
         }
          this.selectedStatus = this.editeMatterInfo.status;
          this.selectedPriority = this.editeMatterInfo.priority;
          this.caseRegister.controls["case_number"].setValue(this.editeMatterInfo.caseNumber);
          //this.caseRegister.controls["matter_number"].setValue(this.editeMatterInfo.matter_number);
          this.caseRegister.controls["case_type"].setValue(this.editeMatterInfo.case_type);
          this.caseRegister.controls["court_name"].setValue(this.editeMatterInfo.courtName);
          this.caseRegister.controls["matter_number"].setValue(this.editeMatterInfo.matter_id);
          this.caseRegister.controls["case_type"].setValue(this.editeMatterInfo.caseType);
          
          if (this.editeMatterInfo?.opponentAdvocates) {
            this.advicates = [...this.editeMatterInfo.opponentAdvocates]; // Ensure deep copy
          } 
          //console.log("matter-info of advicates: ", this.advicates)
          // if (this.editeMatterInfo?.tags){
          //   // this.caseRegister.tags = []
          //   this.tags = [...this.editeMatterInfo.tags]; 
          // } 
          if (this.editeMatterInfo?.tags) {
            this.tags = [...Object.values(this.editeMatterInfo.tags)];
          }
          //console.log("matter-info of tags: ", this.tags)

          this.getDocuments();
          this.getLegalMatters();
        }
        else if(result.error)
        this.toast.error(result.msg)
      })

      const cached = localStorage.getItem('editMatterCache');
      if (cached) {
        const parsed = JSON.parse(cached);
        //console.log('Restored from localStorage', parsed);
        this.applyMatterToForm(parsed);
      }

    }
     // Subscribe to form value changes
     this.caseRegister.valueChanges.subscribe(() => {
      this.isAddDisable = this.checkIfFormHasValue();
     });
  }

selectCaseType(value: string) {
  this.selectedCaseType = value;
  this.caseRegister.get('case_type')?.setValue(value);
  this.isOpen = false;
}

  applyMatterToForm(data: any) {
  this.editeMatterInfo = data;
  this.matterid = data.id;
  this.isEdit = true;

  this.caseRegister.patchValue(data);
  if (data.created_date) {
    this.caseRegister.controls["created_date"].setValue(
      new Date(data.created_date)
    );
  }

  if (data.date_of_filling) {
    this.caseRegister.controls["date_of_filling"].setValue(new Date(data.date_of_filling));
  }

  this.caseRegister.controls["case_number"].setValue(data.caseNumber);
  this.caseRegister.controls["matter_number"].setValue(data.matter_id);
  // this.caseRegister.controls["case_type"].setValue(data.case_type || data.caseType);
  const caseType = data.case_type || data.caseType || '';
  this.caseRegister.controls["case_type"].setValue(caseType);
  this.selectedCaseType = caseType;

  this.caseRegister.controls["court_name"].setValue(data.courtName);

  this.selectedStatus = data.status;
  this.selectedPriority = data.priority;

  if (data?.opponentAdvocates) {
    this.advicates = [...data.opponentAdvocates];
  }

  if (data?.tags) {
    this.tags = [...Object.values(data.tags)];
  }

  this.getDocuments();
  this.getLegalMatters();
}


  getMatterCaseType() {
    this.spinnerService.show();
    this.httpService.sendGetRequest(URLUtils.checkCaseType).subscribe((res: any) => {
      this.spinnerService.hide();
      // console.log("CaseType response:", res);
      this.caseTypes = res.data;
    }); // get case types
  }
  
  getMatterID() {
    this.spinnerService.show();
    this.httpService.sendGetRequest(URLUtils.getMatterId).subscribe((res: any) => {
      this.spinnerService.hide();
      // console.log("MatterId response:", res);
      //this.getMatterId = res.matter_id;
      if (res && res.matter_id) {
        this.caseRegister.get('matter_number')?.setValue(res.matter_id);
      }
    }); // get matter id as prefilled value
  }

  // openDialog() {
  //   this.dialog.open(LeavepageComponent);
  // }

  checkIfFormHasValue(): boolean {
    const controls = Object.values(this.caseRegister.controls) as AbstractControl[];
    return controls.some(control => {
        return control.value && control.value.trim().length > 0;
    });
  }

  get f() {
    return this.caseRegister.controls;
  }
  getDocuments() {
    this.httpService.sendGetRequest(URLUtils.legalHistoryDocuments(this.editeMatterInfo.id)).subscribe(
      (res: any) => {
        if (res) {
          this.Documents = res.documents;
        }
      });
  }
  // get member_name(){
  //   return this.caseRegister.memberDetail.get('member_name') as FormControl;
  // }
  receiveAutoMsgHandler(details: any) {
    //console.log("details: ", details)
    if (details == null) {
      this.isAddDisable = true;
    } else {
      this.isAddDisable= true;
      this.advicates = details;
    }
   // console.log(" this.advicates------------>" + this.advicates)
  } 

  receiveTagMsgHandler(details: any) {
    if (details == null) {
      this.isAddDisable = true;
    } else {
      this.isAddDisable= true;
      this.tags = details;
    }
    // console.log(" details: ", details)
    // console.log(" this.tags------------>" + this.tags)
  } 
  
  getPriority(data: any) {
    this.caseRegister.controls.priority.patchValue(data ? data : "High");

  }
  getStatus(data: any) {
    this.caseRegister.controls.status.patchValue(data ? data : "Active");
  }
  addOpponenteAdvicate() {

  }
    
  // convertTagsToObject(tagsArray: any[]): { [key: string]: string } {
  //   const tagObject: { [key: string]: string } = {};
  //   tagsArray.forEach((tag, index) => {
  //     tagObject[index] = tag.name;
  //   });
  //   return tagObject;
  // }
  convertTagsToObject(tagsArray: any[]): { [key: string]: string } {
    const tagObject: { [key: string]: string } = {};
    tagsArray.forEach((tag, index) => {
      // If tag is an object with a name property, use it; otherwise, assume it's a string
      tagObject[index] = typeof tag === 'string' ? tag : tag.name || '';
    });
    return tagObject;
  }
  

  onSubmit() {
    if (!ensureActiveSubscription(this.confirmationDialogService)) { return; }
    this.submitted = true;
        
    //console.log("caseRegister", this.caseRegister.value)
    if (this.caseRegister.invalid) {
      return;
    }

    //this.caseRegister.value.opponent_advocates = this.advicates;
    // if(this.caseRegister.value.opponent_advocates){
    //   this.caseRegister.value.opponent_advocates = [...this.advicates];
    // }  
  
    if (!Array.isArray(this.advicates)) {
      this.advicates = [];
    }
    this.caseRegister.value.opponent_advocates = [...this.advicates]; // adding advocates
        
    if (!Array.isArray(this.tags)) {
      this.tags = [];
    }
    this.caseRegister.value.tags = [...this.tags]; // adding tags

    // console.log("advicates", this.advicates)
    // console.log("tags", this.tags)
    // console.log('edittag',this.editeMatterInfo)
    // console.log('case type', this.caseTypes)

    let matter = this.caseRegister.value
    // let body = {"title":matter.title, "case_number": matter.case_number, "type": "legal"} 
    // let editbody = {"title":matter.title, "case_number": matter.case_number, "matter_id": matter.matter_number, "type": "legal"}
    let body = {"title":matter.title, "type": "legal"} 
    let editbody = {"title":matter.title, "type": "legal", "matter_id": this.matterId || this.editeMatterInfo?.id}
    // console.log('data',this.data)
    // console.log('eddd matterId', this.matterId)
    // console.log('eddd edittt', this.editeMatterInfo)

    // this.caseRegister.value.status = 'Active'
    // this.caseRegister.value.priority = 'High'
    //this.caseRegister.value.status =this.caseRegister.status=="INVALID" || this.caseRegister.status=="VALID" ?"Active":this.caseRegister.status;
    //this.caseRegister.value.priority = this.caseRegister?.priority? this.caseRegister.priority:"High";
    // console.log(JSON.stringify(this.caseRegister.value));

    if (!this.data && !this.editeMatterInfo) { //!this.matterId
      //console.log("On Add matter info")
      this.spinnerService.show();
      this.httpService.sendPostRequest(URLUtils.checkMatterUnique, body).subscribe((res: any) => {
        this.spinnerService.hide();
        if (res.error) {
          this.toast.error(res.msg)
          // this.confirmationDialogService.confirm('Alert', res.msg, false, 'OK', 'Cancel', true)
          //   .then((confirmed) => {
          //     if (confirmed) {
          //     }
          //   })
          return
        }
        else {
          //console.log("inside matter-info: ", this.caseRegister.value)
          this.childButtonEvent.emit(this.caseRegister.value);
        }
      })
      // this.childButtonEvent.emit(this.caseRegister.value);
    }
    else if (window.location.pathname.indexOf("edit") > -1) {
      //this.toast.info('saving...')
      //console.log("On Edit matter info 111")
      //console.log('edit caseRegister.value 1',this.caseRegister.value)
      //console.log('this.editeMatterInfo?.members',this.editeMatterInfo?.members)
      // this.caseRegister.value.date_of_filling = this.pipe.transform(this.caseRegister.value.date_of_filling, 'dd-MM-yyyy');
      let data = {
        "title": this.caseRegister.value.title,
        "case_number": this.caseRegister.value.case_number,
        //"matter_number": this.caseRegister.value.created_date,
        "created_date": this.datePipe.transform(
          this.caseRegister.value.created_date,
          'dd-MM-yyyy'
        ),
        // "tags": this.tags,
        //"date_of_filling": this.pipe.transform(this.caseRegister.value.date_of_filling, 'dd-MM-yyyy'),
        "date_of_filling": this.caseRegister.value.date_of_filling ? this.pipe.transform(this.caseRegister.value.date_of_filling, 'dd-MM-yyyy') : null,
        "description": this.caseRegister.value.description,
        "case_type": this.caseRegister.value.case_type,
        "court_name": this.caseRegister.value.court_name,
        "judges": this.caseRegister.value.judges,
        "priority": this.caseRegister.value.priority,
        "status": this.caseRegister.value.status,
        "affidavit_isfiled": "na",
        "affidavit_filing_date": "",
        "opponent_advocates": this.advicates?.length > 0 ? this.advicates : [],
        "tags": this.tags?.length > 0 ? this.convertTagsToObject(this.tags) : {},
        // "clients": this.editeMatterInfo?.clients.map((obj: any) => ({ "id": obj.id, "type": obj.type })),
        // "clients": [
        //   ...(this.editeMatterInfo?.clients?.map((obj: any) => ({ "id": obj.id, "type": obj.type })) || []),
        //   ...(Array.isArray(this.editeMatterInfo?.corporate) ?
        //     this.editeMatterInfo.corporate.map((obj: any) => ({ "id": obj.id, "type": obj.type }))
        //     : [])
        // ],
        //"group_acls": this.editeMatterInfo.groupAcls,
        //"members": this.editeMatterInfo?.members.map((obj: any) => ({ "id": obj.id })),
        // "members": this.editeMatterInfo?.members.map((obj: any) => ({ "id": obj.id })).filter((member: any, index: any, self: any[]) => index === self.findIndex((m) => m.id === member.id)),
        // "documents": this.Documents?.map((obj: any) => ({
        //   "docid": obj.docid,
        //   "doctype": obj.doctype,
        //   "user_id": obj.user_id,
        //  ))
      }
      // console.log('payload data', data)
      // console.log('added matterId', this.matterId)

      this.spinnerService.show();
      this.httpService.sendPostRequest(URLUtils.checkMatterUnique, editbody).subscribe((res: any) => {
      this.spinnerService.hide();
        if (res.error) {
          this.confirmationDialogService.confirm('Alert', res.msg, false, 'OK', 'Cancel', true)
            .then((confirmed) => {
              if (confirmed) {
              }
            })
          return;
        }
        else {
          this.httpService.sendPatchRequest(URLUtils.updateLegalMatter(this.matterId || this.editeMatterInfo?.id), data).subscribe((res: any) => {
          this.spinnerService.hide();
            if (!res.error) {
              // go to the next step
              //this.childButtonEvent.emit(this.caseRegister.value);
                this.toast.success("Matter Info updated successfully");
                 this.childButtonEvent.emit({
                  ...this.caseRegister.value,
                  matter_id: this.matterId ?? this.editeMatterInfo?.id,
                  isEdit: true
                });
              // this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully updated the matter information.', false, 'View Matter List', '', true, 'sm', true, true)
              //   .then((confirmed) => {
              //     if (confirmed) {
              //       this.router.navigate(['/matter/legalmatter/view']);
              //     }
              //   })
            }
            else {
              this.toast.error(res.msg)
            }
          }, (error: HttpErrorResponse) => {
            this.spinnerService.hide();
            if (error.status === 401 || error.status === 403) {
              const errorMessage = error.error.msg || 'Unauthorized';
              this.toast.error(errorMessage);
            }
          }
          )
        }
      })
    }
    else {
      //console.log("On Edit matter info 222")
      //console.log('edit caseRegister.value 2',this.caseRegister.value)
      // this.caseRegister.value.date_of_filling = this.pipe.transform(this.caseRegister.value.date_of_filling, 'dd-MM-yyyy');
      let data = {
        "title": this.caseRegister.value.title,
        "case_number": this.caseRegister.value.case_number,
        "matter_number": this.caseRegister.value.matter_number,
        // "tags": this.tags,
        //"date_of_filling": this.pipe.transform(this.caseRegister.value.date_of_filling, 'dd-MM-yyyy'),
        "date_of_filling": this.caseRegister.value.date_of_filling ? this.pipe.transform(this.caseRegister.value.date_of_filling, 'dd-MM-yyyy') : null,
        "description": this.caseRegister.value.description,
        "case_type": this.caseRegister.value.case_type,
        "court_name": this.caseRegister.value.court_name,
        "judges": this.caseRegister.value.judges,
        "priority": this.caseRegister.value.priority,
        "status": this.caseRegister.value.status,
        "affidavit_isfiled": "na",
        "affidavit_filing_date": "",
        "created_date": this.datePipe.transform(
          this.caseRegister.value.created_date,
          'dd-MM-yyyy'
        ),
        "opponent_advocates": this.advicates?.length > 0 ? this.advicates : [],
        "tags": this.tags?.length > 0 ? this.convertTagsToObject(this.tags) : {},
        // "clients": this.editeMatterInfo?.clients.map((obj: any) => ({ "id": obj.id, "type": obj.type })),
        "clients": [
          ...(this.editeMatterInfo?.clients?.map((obj: any) => ({ "id": obj.id, "type": obj.type })) || []),
          ...(Array.isArray(this.editeMatterInfo?.corporate) ?
            this.editeMatterInfo.corporate.map((obj: any) => ({ "id": obj.id, "type": obj.type }))
            : [])
        ],
        //"group_acls": this.editeMatterInfo.groupAcls,
        //"members": this.editeMatterInfo?.members.map((obj: any) => ({ "id": obj.id })),
        "members": this.editeMatterInfo?.members.map((obj: any) => ({ "id": obj.id })).filter((member: any, index: any, self: any[]) => index === self.findIndex((m) => m.id === member.id)),
        "documents": this.Documents?.map((obj: any) => ({
          "docid": obj.docid,
          "doctype": obj.doctype,
          "user_id": obj.user_id
        }))
      }
      // console.log('payload data', data)
      // console.log('added matterId', this.matterId)

      this.httpService.sendPatchRequest(URLUtils.updateLegalMatter(this.matterId || this.editeMatterInfo?.id), data).subscribe((res: any) => {
        if (!res.error) {
          //this.toast.success("Matter Info updated successfully");
          this.childButtonEvent.emit(this.caseRegister.value);
        }
        else {
          this.toast.error(res.msg)
        }
      }, (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
        }
      })
      return
    }

    // this.isGroups=true;
    // console.log('submit form',this.caseRegister.value)
    this.getLegalMatters();
  }

  addEvent(type: string, event: any) {
    this.events.push(`${type}: ${event.value}`);
    //console.log("Date --->" + this.events);
  }
    
  OnCancel() {
    let caseReg = this.caseRegister.value
    localStorage.setItem('oncancel', "oncancel");

    const hasValidInput =
      (this.caseRegister.get('title').touched && caseReg.title.trim().length > 0) ||
      (this.caseRegister.get('case_number').touched && caseReg.case_number.trim().length > 0) ||
      (this.caseRegister.get('matter_number').touched && caseReg.matter_number.trim().length > 0) ||
      (this.caseRegister.get('case_type').touched && caseReg.case_type.trim().length > 0) ||
      (this.caseRegister.get('court_name').touched && caseReg.court_name.trim().length > 0) ||
      (this.caseRegister.get('date_of_filling').touched && this.pipe.transform(caseReg.date_of_filling,'dd-MM-yyyy')) ||
      (this.caseRegister.get('description').touched && caseReg.description.trim().length > 0) ||
      (this.caseRegister.get('judges').touched && caseReg.judges.trim().length > 0) ||
      (this.caseRegister.get('priority').touched && caseReg.priority.trim().length > 0) ||
      (this.caseRegister.get('status').touched && caseReg.status.trim().length > 0) ||
      (this.caseRegister.get('tags').touched && caseReg.tags.trim().length > 0);

    // if (this.isEdit) {
    //   this.router.navigate(['/matter/legalmatter/view']);
    // }
    // else {
      // console.log('data',this.data)
      // console.log('hasValidInput',hasValidInput)

      if (hasValidInput) {
       // this.onSubmit();
        this.dialog.open(LeavepageComponent, {
          width: '350px',  // Set the width here
          height: '180px',
          hasBackdrop: true,
          panelClass: 'hello',
          disableClose: true
        });
        return;
      }
      else{
         this.router.navigate(['/matter/legalmatter/view']);
      }
    //}
  }

  OnSaveLater() {
    let caseReg = this.caseRegister.value
    localStorage.setItem('oncancel', "oncancel");

    const hasValidInput =
      (this.caseRegister.get('title').touched && caseReg.title.trim().length > 0) ||
      (this.caseRegister.get('case_number').touched && caseReg.case_number.trim().length > 0) ||
      (this.caseRegister.get('matter_number').touched && caseReg.matter_number.trim().length > 0) ||
      (this.caseRegister.get('case_type').touched && caseReg.case_type.trim().length > 0) ||
      (this.caseRegister.get('court_name').touched && caseReg.court_name.trim().length > 0) ||
      (this.caseRegister.get('date_of_filling').touched && this.pipe.transform(caseReg.date_of_filling,'dd-MM-yyyy')) ||
      (this.caseRegister.get('description').touched && caseReg.description.trim().length > 0) ||
      (this.caseRegister.get('judges').touched && caseReg.judges.trim().length > 0) ||
      (this.caseRegister.get('priority').touched && caseReg.priority.trim().length > 0) ||
      (this.caseRegister.get('status').touched && caseReg.status.trim().length > 0) ||
      (this.caseRegister.get('tags').touched && caseReg.tags.trim().length > 0);

    if (this.isEdit) {
      this.spinnerService.show();
      setTimeout(() => {
        this.spinnerService.hide();
        this.getLegalMatters();

        this.router.navigate(
          ['/matter/legalmatter/view'],
          {
            state: {
              refresh: true
            }
          }
        );
      }, 1000);
      return;
    }
    else {
      // console.log('data',this.data)
      // console.log('hasValidInput',hasValidInput)

      if (hasValidInput || this.data) {
        this.onSubmit();
        // this.dialog.open(LeavepageComponent, {
        //   width: '350px',  // Set the width here
        //   height: '180px',
        //   hasBackdrop: true,
        //   panelClass: 'hello',
        //   disableClose: true
        // });
        // return;
      }
      else{
         this.router.navigate(['/matter/legalmatter/view']);
      }
    }
    //else {
      //this.caseRegister.reset();
      // this.caseRegister.patchValue({
      //   title: '',
      //   case_number: '',
      //   date_of_filling: '',
      //   description: '',
      //   tags: '',
      //   case_type: '',
      //   court_name: '',
      //   judges: '',
      //   status: ['Active'],
      //   priority: ['High']
      //});
    //}
  }
  restricttextSpace(event: any) {
    let inputValue: string = event.target.value;
    inputValue = inputValue.replace(/^\s+/, '');
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    event.target.value = inputValue;
    return;
  }
  getLegalMatters() {
    this.httpService.sendGetRequest(URLUtils.getLegalMatter).subscribe((res: any) => {
      if (res && res["matters"]) {
        this.legalMatters = res["matters"].map((matter: any) => {
          const uniqueMembers = new Map(); // Remove duplicate members
          matter?.members?.forEach((member: any) => {
            if (!uniqueMembers.has(member.id)) {
              uniqueMembers.set(member.id, member);
            }
          });
          matter.members = Array.from(uniqueMembers.values());
          matter.groups = matter?.groups?.filter((group: any) => 
            group.name !== 'AAM' && group.name !== 'SuperUser'
          );
          return matter;
        });
      }
    })
  }

  clearFilingDate(event: Event) {
    event.stopPropagation(); // prevent opening datepicker
    this.caseRegister.get('date_of_filling')?.setValue(null);
  }

}
